/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m19.9964548 30c-.2585934 0-.5171868-.1017522-.7141622-.3073546l-15.98632438-16.6013443c-.18990452-.1961614-.29596822-.4636543-.29596822-.7416372v-8.3006721c0-.57904347.45152831-1.0489918 1.01013044-1.0489918h7.99316216c.2686947 0 .5242577.11119313.7141623.3073546l15.9863243 16.6013443c.3949611.4101558.3949611 1.0741676 0 1.4832744l-7.9931621 8.3006721c-.1969755.2056024-.4555689.3073546-.7141623.3073546zm-14.97619391-18.0846187 14.97619391 15.5523525 6.5648378-6.8173977-14.976194-15.5523525h-6.56483771zm6.38907501-2.5301682c0 1.3080928-1.022252 2.3675745-2.28188463 2.3675745-1.25963267 0-2.28188467-1.0594817-2.28188467-2.3675745 0-1.30809278 1.022252-2.3675745 2.28188467-2.3675745 1.25963263 0 2.28188463 1.05948172 2.28188463 2.3675745z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;